module.exports = __webpack_public_path__ + "static/media/MB-logo.29b3f463.png";